import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=32845fad&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32845fad')) {
      api.createRecord('32845fad', component.options)
    } else {
      api.reload('32845fad', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=32845fad&", function () {
      api.rerender('32845fad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8qFO9M8xZMEj8/JS/comp/DateRangeExt.vue"
export default component.exports